import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import NumberPicker from 'components/shared/NumberPicker'
import { useIntl } from 'react-intl'
import { BUS_TICKETS_LIMIT } from 'constants/limits'

interface BusPeopleProps {
    ticketsAmount: number
    limit: number | null
    setTicketsAmount: (ticketsAmount: number) => void
    index: number
}

export const BusPeople = ({
    ticketsAmount,
    limit,
    setTicketsAmount,
    index,
}: BusPeopleProps) => {
    const { formatMessage } = useIntl()

    return (
        <Box
            mt={[24, 40]}
            gap={16}
            isFullWidth
            direction={['row', 'column']}
            align={['center', 'flex-start']}
        >
            <Text variant="heading4">
                {formatMessage({
                    id: 'global.input.people_quantity_label',
                    defaultMessage: 'Liczba osób',
                })}
            </Text>
            <NumberPicker
                minValue={1}
                maxValue={limit || BUS_TICKETS_LIMIT}
                value={ticketsAmount}
                handleAdd={() => setTicketsAmount(ticketsAmount + 1)}
                handleSubtract={() => setTicketsAmount(ticketsAmount - 1)}
                testIdPrefix={`transport-${index}`}
            />
        </Box>
    )
}
